import { render, staticRenderFns } from "./r-money-panel.vue?vue&type=template&id=9037428e"
import script from "./r-money-panel.vue?vue&type=script&lang=js"
export * from "./r-money-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9037428e')) {
      api.createRecord('9037428e', component.options)
    } else {
      api.reload('9037428e', component.options)
    }
    module.hot.accept("./r-money-panel.vue?vue&type=template&id=9037428e", function () {
      api.rerender('9037428e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-money-panel.vue"
export default component.exports